import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { Cstcofins } from '../model/cstcofins.model';

@Injectable()
export class CstCofinsService extends EntityService<Cstcofins> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'cstcofin',
      pluralBaseEntityEndPoint: 'cstcofinss',
      urlBackend: configService.backendURL
    });
  }
}
